import { render, staticRenderFns } from "./RipaFavoritesDialog.vue?vue&type=template&id=f4c69d56"
import script from "./RipaFavoritesDialog.vue?vue&type=script&lang=js"
export * from "./RipaFavoritesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports